import { RootState } from "@src/store";
import { getPageState } from "@src/store/slices/experienceBuilder/common/selectors/getPageState";

export const isPageLoading = (state: RootState) =>
  getPageState(state)?.type === "loading";
